<template>
  <div
    class="registrant-base-data"
    :class="{
      'display-only':isDisplayOnly,
    }">

    <div
      v-if="isDisplayOnly"
      class="row mb-3">
      <!-- First Name -->
      <div class="col-sm">
        <small class="text-danger">
          Note: These fields are always collected on a registration, you do not need to add them again.
        </small>
      </div>
    </div>

    <div class="row">
      <!-- First Name -->
      <div class="col-sm">
        <label for="base-first-name">First Name: <small class="text-danger">required</small></label>
        <b-form-input
          id="base-first-name"
          type="text"
          v-model="registrant.first_name"
          :placeholder="isDisplayOnly ? '' : 'Enter the registrant\'s first name'"
          :readonly="isDisplayOnly">
        </b-form-input>
      </div>
      <!-- / First Name -->

      <!-- Middle Name -->
      <div class="col-sm mt-3 mt-sm-0">
        <label for="base-middle-name">Middle Name:</label>
        <b-form-input
          id="base-middle-name"
          type="text"
          v-model="registrant.middle_name"
          :placeholder="isDisplayOnly ? '' : 'Enter the registrant\'s middle name'"
          :readonly="isDisplayOnly">
        </b-form-input>
      </div>
      <!-- / Middle Name -->

      <!-- Last Name -->
      <div class="col-sm mt-3 mt-sm-0">
        <label for="base-last-name">Last Name: <small class="text-danger">required</small></label>
        <b-form-input
          id="base-last-name"
          type="text"
          v-model="registrant.last_name"
          :placeholder="isDisplayOnly ? '' : 'Enter the registrant\'s last name'"
          :readonly="isDisplayOnly">
        </b-form-input>
      </div>
      <!-- / Last Name -->
    </div>

    <div class="row mt-3">
      <!-- DOB -->
      <div class="col-sm">
        <label for="base-date-of-birth">DOB: <small class="text-danger">required</small></label>
        <b-form-input
          id="base-date-of-birth"
          type="date"
          v-model="registrant.birthdate"
          :placeholder="isDisplayOnly ? '' : 'Enter the registrant\'s date of birth'"
          :readonly="isDisplayOnly">
        </b-form-input>
      </div>
      <!-- / DOB -->

      <!-- Middle Name -->
      <div class="col-sm mt-3 mt-sm-0">
        <label for="base-email">Email: <small class="text-danger">required</small></label>
        <b-form-input
          id="base-email"
          type="email"
          v-model="registrant.email"
          :placeholder="isDisplayOnly ? '' : 'Enter the registrant\'s email address'"
          :readonly="isDisplayOnly">
        </b-form-input>
      </div>
      <!-- / Middle Name -->

      <!-- Last Name -->
      <div class="col-sm mt-3 mt-sm-0">
        <label for="base-phone">Phone: <small class="text-danger">required</small></label>
        <b-form-input
          id="base-phone"
          type="tel"
          v-model="registrant.primary_phone"
          :placeholder="isDisplayOnly ? '' : 'Enter the registrant\'s phone number'"
          :readonly="isDisplayOnly">
        </b-form-input>
      </div>
      <!-- / Last Name -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'registrant-base-data',
  props: [
    'value',
    'displayOnly',
  ],
  data() {
    return {
      isDisplayOnly: this.displayOnly === '',
      registrant: this.displayOnly === '' ? {} : this.value,
    };
  },
};
</script>

<style lang="scss">
.registrant-base-data {
  [readonly] {
    background-color: #ffffff !important;
    pointer-events: none;
  }

  &.display-only {
    background: #eeeeee;
    padding: 15px;
    margin: 15px -15px 0 -15px;
  }
}
</style>
